export const REC_PDF_DOCUMENT_DEFAULT_WIDTH = 612;
export const REC_PDF_DOCUMENT_DEFAULT_HEIGHT = 792;
